import { SpendQueryType } from "../../../hooks/useCompanySpend";
import { SpendBreakdownCard } from "./SpendBreakdownCard";

export const AISpendBreakdown = () => (
  <SpendBreakdownCard
    title="AI Spend Breakdown"
    testIdPrefix="company-detail-ai-spend-breakdown"
    queryType={SpendQueryType.AI_BY_CATEGORY}
    caption="Generative AI overlaps AI Hardware, Software and Services."
    emptyMessage="No AI spend estimate available for this company."
    rootName="Total AI Spend"
  />
);
